import { render, staticRenderFns } from "./12zhihuijiaoyu.vue?vue&type=template&id=1b14d75f&scoped=true&"
import script from "./12zhihuijiaoyu.vue?vue&type=script&lang=js&"
export * from "./12zhihuijiaoyu.vue?vue&type=script&lang=js&"
import style0 from "./12zhihuijiaoyu.vue?vue&type=style&index=0&id=1b14d75f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b14d75f",
  null
  
)

export default component.exports